import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=6bb828e2&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePreview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=6bb828e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb828e2",
  null
  
)

export default component.exports